module.exports = __webpack_public_path__ + "0ad829222a2ac6a430acda066dd32b53.png";